import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {ReservationService} from "app/services";
import {filterSchedules} from "./filter-schedules.slice";
import store from "../../../store";
import { getAccount } from "app/account/store/get-account.slice";

interface DisableFlight {
  travelerId: string;
  flight: string;
  onSuccess?: Function;
  onError?: Function;
}

export const disableFlight =
    (params: DisableFlight) => async (dispatch: Dispatch) => {
      const filters = store.getState().schedules.filterSchedules;
      try {
        dispatch(setLoading(true));
        const response = await ReservationService.disableFlightFromTraveler(
            params.travelerId, params.flight);
        if (response.status >= 200 || response.status < 300) {
          dispatch(setSuccess(true));
          dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Flight changed successfully!' : 'Fluturimi u ndërrua me sukses!'));
          if (params.onSuccess) params.onSuccess();
          dispatch(getAccount() as any);
          dispatch(setError(""));
          // @ts-ignore
          dispatch(
              // @ts-ignore
              filterSchedules({
                ...filters,
                page: 0,
              })
          );
        }
        dispatch(setLoading(false));
      } catch (err) {
        dispatch(setLoading(false));
        dispatch(errorMsg(err.data.message));
        if (params.onError) params.onError();
        dispatch(setError(err.data.message));
      }
    };

interface DisableFlightSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: DisableFlightSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "schedules/flight-traveler/disable",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
